import { render, staticRenderFns } from "./old.vue?vue&type=template&id=f7be71ac&scoped=true&"
import script from "./old.vue?vue&type=script&lang=js&"
export * from "./old.vue?vue&type=script&lang=js&"
import style0 from "./old.vue?vue&type=style&index=0&id=f7be71ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7be71ac",
  null
  
)

export default component.exports